import React from 'react';
import SEO from '../components/common/SEO';
import ResourceHero from '../components/resources/ResourceHero';
import ToolGrid from '../components/resources/ToolGrid';

const Resources = () => {
  return (
    <div className="bg-white">
      <SEO 
        title="Creator Stack & Resources" 
        description="The exact tools and systems I use to build digital products and manage ADHD productivity." 
        canonical="/resources" 
      />
      <ResourceHero />
      <ToolGrid />
    </div>
  );
};

export default Resources;